import {BannerDataImage, type IBannerDataImageOptions} from '@core-client/ads/banner/data/BannerDataImage';
import {BannerDataJson} from '@core-client/ads/banner/data/BannerDataJson';
import {BannerDataNull} from '@core-client/ads/banner/data/BannerDataNull';
import {BannerDataText} from '@core-client/ads/banner/data/BannerDataText';
import type {IBannerData} from '@core-client/ads/banner/data/IBannerData';
import {parseJson} from './util/BannerCommon';
import type {ValueProvider} from './util/ValueProvider';

export interface IResponseListener {
    handleResponse: (bannerData: IBannerData) => unknown;
}

interface IRequestCancellationListener {
    onCancel?: () => unknown;
}

export class BannerRequest {
    container: HTMLElement;
    ready: IResponseListener;
    slot: ValueProvider<string>;
    bannerPlace: string | null;
    response?: IBannerData;
    cancellationListener?: IRequestCancellationListener;

    constructor(container: HTMLElement, ready: IResponseListener, slot: ValueProvider<string>, bannerPlace: string) {
        this.container = container;
        this.ready = ready;
        this.slot = slot;
        if (bannerPlace) {
            this.bannerPlace = bannerPlace;
        } else {
            this.bannerPlace = container ? container.getAttribute('data-place') : null;
        }
    }

    getResponse(): IBannerData {
        return this.response!;
    }

    cancel() {
        this.cancellationListener?.onCancel?.();
    }

    handleResponse(response: string | null) {
        if (!response) { // Если пустой ответ, то баннера нет
            this.response = BannerDataNull.NULL;
        } else {
            const json = this.tryParseJSON(response);
            if (json === null) {
                this.response = new BannerDataText(response);
            } else {
                if (json.hasOwnProperty(BannerDataJson.INTERNAL_IMG_URL_KEY)) {
                    this.response = new BannerDataImage(json as IBannerDataImageOptions);
                } else {
                    this.response = BannerDataNull.NULL;
                }
            }
        }
        this.handleBannerDataResponse(this.response);
        return this.response;
    }

    handleBannerDataResponse(bannerData: IBannerData) {
        this.ready.handleResponse(bannerData);
    }

    tryParseJSON(json: string): object | null {
        try {
            return parseJson(json);
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        } catch (e) {
            return null;
        }
    }

    setCancellationListener(cancellationListener: IRequestCancellationListener) {
        this.cancellationListener = cancellationListener;
    }
}
